/* eslint-disable */
/**
 *
 * @param value number assertions
 * @returns number assertions
 */

import { Dict } from '../types'

export function isNumber(value: any): value is number {
  return typeof value === 'number'
}

export function isNotNumber(value: any) {
  return (
    typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value)
  )
}

export function isNumeric(value: any) {
  return value != null && value - parseFloat(value) + 1 >= 0
}

/**
 *
 * @param value array assertions
 * @returns Array assertions
 */

export function isArray<T>(value: any): value is Array<T> {
  return Array.isArray(value)
}

export function isEmptyArray(value: any) {
  return isArray(value) && value.length === 0
}

/**
 *
 * @param value generic assertions
 * @returns generic assertions
 */
export function isDefined(value: any) {
  return typeof value !== 'undefined' && value !== undefined
}

export function isUndefined(value: any): value is undefined {
  return typeof value === 'undefined' || value === undefined
}

/**
 *
 * @param value object assertions
 * @returns object assertions
 */

export function isObject(value: any): value is Dict {
  const type = typeof value
  return (
    value != null &&
    (type === 'object' || type === 'function') &&
    !isArray(value)
  )
}

export function isEmptyObject(value: any) {
  return isObject(value) && Object.keys(value).length === 0
}

export function isNotEmptyObject(value: any): value is object {
  return value && !isEmptyObject(value)
}

export function isNull(value: any): value is null {
  return value == null
}

/**
 *
 * @param value string assertions
 * @returns string assertions
 */
export function isString(value: any): value is string {
  return Object.prototype.toString.call(value) === '[object String]'
}

export function isCssVar(value: string): boolean {
  return /^var\(--.+\)$/.test(value)
}

/**
 *
 * @param value Empty assertions
 * @returns Empty assertions
 */
export function isEmpty(value: any): boolean {
  if (isArray(value)) return isEmptyArray(value)
  if (isObject(value)) return isEmptyObject(value)
  if (value == null || value === '') return true
  return false
}

export function isRefObject(val: any): val is { current: any } {
  return 'current' in val
}

export function isInputEvent(
  value: any,
): value is { target: HTMLInputElement } {
  return value && isObject(value) && isObject(value.target)
}

/**
 * Checks whether or not a value is a function.
 *
 * @param value
 */
export function isFunction(value: any): value is Function {
  // eslint-disable-next-line eqeqeq
  return !!(value && {}.toString.call(value) == '[object Function]')
}
